import React, { memo, useEffect, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';

import * as _ from 'lodash';
import { log } from 'utils';

export function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

function ChartPBDongTien({ pbDongTien, t, theme }) {
  const abortController = new AbortController();

  const DEFAULT_OPTION = {
    grid: { top: 20, right: 10, bottom: 30, left: 40 },
    color: ['#0FC786', '#F5465C', '#F0B90B'],
    tooltip: {
      show: false,
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)',
    },
    legend: {
      show: false,
    },
    xAxis: {
      type: 'category',
      data: [
        t('algo.bdkt.txt-advance'),
        t('algo.bdkt.txt-decline'),
        t('algo.bdkt.txt-no-change'),
      ],
      splitLine: {
        show: false,
        lineStyle: {
          type: 'dashed',
          color: '#4E4D62',
          dashOffset: 10,
          opacity: 0.3,
        },
      },
      axisTick: {
        show: false,
        alignWithLabel: false,
        length: 3,
      },
      axisLabel: {
        color: theme === 'dark' ? '#ECECEC' : '#000000',
        fontSize: 8,
        borderColor: theme === 'dark' ? '#ECECEC' : '#000000',
      },
    },
    yAxis: {
      type: 'value',
      show: true,
      position: 'left',
      alignTicks: true,
      splitNumber: 4,
      splitLine: {
        // show: false,
        lineStyle: {
          type: 'dashed',
          color: '#4E4D62',
          dashOffset: 10,
          opacity: 0.3,
        },
      },
      axisLabel: {
        color: theme === 'dark' ? '#ECECEC' : '#000000',
        fontSize: 8,
        showMinLabel: true,
        showMaxLabel: false,
        formatter: function (value, index) {
          return value + ' tỷ';
        },
      },
    },
    series: [
      {
        type: 'bar',
        label: {
          show: true,
          position: 'top',
          distance: 15,
          align: 'center',
          verticalAlign: 'top',
          rotate: 0,
          formatter: '{c} ' + t('algo.bdkt.txt-bil'),
          fontSize: 8,
          rich: {
            name: {},
          },
          color: theme === 'dark' ? '#ECECEC' : '#000000',
          borderWidth: 0,
          borderColor: theme === 'dark' ? '#ECECEC' : '#000000',
        },
        emphasis: {
          focus: 'series',
        },
        data: [],
      },
    ],
  };

  const [option, setOption] = useState(DEFAULT_OPTION);
  const prePbDongTien = usePrevious(pbDongTien);
  // log(pbDongTien);

  useEffect(() => {
    // _mapDataToState();

    return () => {
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    if (pbDongTien && !_.isEqual(pbDongTien, prePbDongTien)) {
      _mapDataToState();
    }
  }, [pbDongTien]);

  function _mapDataToState() {
    const newOption = _.cloneDeep(option);

    // // log(newOption);
    const _data = [
      {
        value: (pbDongTien?.SumAdvanceVal / 1000).toFixed(2),
        itemStyle: {
          color: '#0FC786',
        },
      },
      {
        value: (pbDongTien?.SumDeclineVal / 1000).toFixed(2),
        itemStyle: {
          color: '#F5465C',
        },
      },
      {
        value: (pbDongTien?.SumNoChangeVal / 1000).toFixed(2),
        itemStyle: {
          color: '#F0B90B',
        },
      },
    ];
    newOption.series[0].data = _data;
    setOption(newOption);
  }

  return (
    <ReactECharts
      option={option}
      style={{
        height: '120px',
        width: `100%`,
      }}
    />
  );
}

export default memo(ChartPBDongTien);
